import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const CancelPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center text-center p-6">
      <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg max-w-lg w-full">
        <XCircle className="text-red-500 w-16 h-16 mx-auto mb-6" />
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
          Paiement Annulé
        </h1>
        <p className="text-slate-600 text-lg mb-8">
          Le processus de paiement a été interrompu. Vous pouvez réessayer à tout moment.
        </p>
        <Link
          to="/subscribe" // Redirige vers la page d'abonnements
          className="bg-slate-900 text-white font-bold py-3 px-6 rounded-lg hover:bg-slate-800 transition-colors shadow-sm"
        >
          Voir les offres
        </Link>
      </div>
    </div>
  );
};

export default CancelPage;
